var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 62a30 30 0 1 1 30-30 2 2 0 0 1-4 0 26 26 0 1 0-26 26 2 2 0 0 1 0 4z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 20H9a2 2 0 0 1 0-4h46a2 2 0 0 1 0 4zM32 34H4a2 2 0 0 1 0-4h28a2 2 0 0 1 0 4zM26 48H9a2 2 0 0 1 0-4h17a2 2 0 0 1 0 4z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 62c-8.411 0-15-13.178-15-30S23.589 2 32 2c7.229 0 13.271 9.786 14.691 23.8a2 2 0 0 1-3.98.4C41.544 14.685 36.938 6 32 6c-5.2 0-11 10.678-11 26s5.8 26 11 26a2 2 0 0 1 0 4z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 62a16 16 0 1 1 16-16 16.019 16.019 0 0 1-16 16zm0-28a12 12 0 1 0 12 12 12.013 12.013 0 0 0-12-12z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 51a2 2 0 0 1-1.414-3.414L44 45.172V38a2 2 0 0 1 4 0v8a2 2 0 0 1-.586 1.414l-3 3A1.992 1.992 0 0 1 43 51z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneIcon);
export default __webpack_public_path__ + "static/media/zone-icon.84bcbf2f0b074fbc5887808ad21acc2b.svg";
export { ForwardRef as ReactComponent };